import React from 'react';
import {LinesContext} from "@web/hooks/context";
import PropTypes from "prop-types";
import WorkflowEditor from "./WorkflowEditor";
import {generateID} from '@web/lib/firestore.db';

CreateApp.propTypes = {
  list: PropTypes.array,
}

function CreateApp() {
  const linesContext = React.useContext(LinesContext);
  const [workflowId] = React.useState(linesContext.objectId || `${linesContext.collectionId}/${generateID()}`);
  return <WorkflowEditor workflowId={workflowId} />;
}

export default CreateApp;
